var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddMyAvatarButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.472,
    height: 32.472,
    transform: "translate(0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9882 19572)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.5,
    cy: 55,
    rx: 55.5,
    ry: 55,
    transform: "translate(-9881 -19571)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9802.837 -19516.604) rotate(135)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.908,32.582a3.677,3.677,0,0,1-2.6-1.074L16.291,21.488,6.272,31.507a3.675,3.675,0,0,1-5.2-5.2L11.093,16.291,1.074,6.272a3.675,3.675,0,0,1,5.2-5.2L16.291,11.093,26.309,1.074a3.672,3.672,0,0,1,5.2,5.188L21.488,16.282,31.507,26.3a3.673,3.673,0,0,1-2.6,6.272",
    transform: "translate(-0.055 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMyAvatarButton);
export default __webpack_public_path__ + "static/media/addMyAvatarButton.45f9f329acd97c6a7fe8f8f353cc4435.svg";
export { ForwardRef as ReactComponent };